import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUnreadMessagesCount } from '../services/getUnreadMessagesCount.service';

export const getUnreadMessagesCountThunk = createAsyncThunk(
  'projectEmail/getUnreadMessagesCount',
  async () => {
    return await getUnreadMessagesCount();
  }
);
